import { SimpleGrid } from '@mantine/core'
import { capitalizeFirstLetter } from '@ospace/common/utils/object'
import { Metrics, sum } from '@ospace/shared'

import { MetricSummary } from '../data-and-intelligence/MetricSummary'

export const CampaignOverview = (props: { campaign: any; metrics: any }) => {
  const { campaign, metrics } = props

  const metricsMapped: any = {
    intents: metrics.no_of_reports,
    companiesDiscovered: metrics.discovery.companies,
    contactsDiscovered: metrics.discovery.contacts,
    meetingBooked:
      Number(metrics.teleSalesOutreach['Upcoming Meetings']) +
      Number(metrics.teleSalesOutreach['Meetings Completed']),
    mcoActivities: metrics.total_hubspot_mco_activities,
    targetPipelineValue: metrics.currentARR.value || 0,
    digitalLeads:
      Number(metrics.total_digital_outreach) ||
      Number(metrics.total_emails_replied || 0) + Number(metrics.total_linkedin_replied || 0),
    highlyEngagedDeals: Number(metrics.highly_engaged_deals) || 0,
    connectionRequestsSent: metrics.total_linkedin_requests_sent,
    connectionRequestsAccepted: metrics.total_linkedin_requests_accepted,
  }

  const isMetricEnabled = (key: keyof typeof Metrics) => {
    if (key === 'highlyEngagedDeals') {
      return campaign.objective.isDigitalLeadsEnabled
    }

    return campaign.objective[`is${capitalizeFirstLetter(key)}Enabled`]
  }

  const renderMetricInfo = (title: string, metrics: (keyof typeof Metrics)[]) => ({
    title,
    metrics: metrics
      // .filter((key) => campaign.objective[key])
      .map((key) => ({
        title: Metrics[key],
        link: `/campaign/data-intel/${campaign.id}/dashboard/${key}`,
        target: campaign.objective[key],
        enabled: isMetricEnabled(key),
        value: metricsMapped[key] || sum(campaign.objective.results, key),
      })),
  })

  return (
    <>
      <SimpleGrid cols={2} p={'xl'}>
        {!!campaign.objective?.isDataIntelligenceActive && (
          <MetricSummary
            metricInfo={renderMetricInfo('Data and Intelligence', [
              'intents',
              'companiesDiscovered',
              'contactsDiscovered',
            ])}
          />
        )}

        {!!campaign.objective?.isTeleProspectingActive && (
          <MetricSummary
            metricInfo={renderMetricInfo('MCO', [
              'meetingBooked',
              'mcoActivities',
              'targetPipelineValue',
            ])}
          />
        )}

        {!!campaign.objective?.isDigitalProspectingActive && (
          <MetricSummary
            metricInfo={renderMetricInfo('Digital Prospecting', [
              'digitalLeads',
              'highlyEngagedDeals',
              'connectionRequestsSent',
              'connectionRequestsAccepted',
              'impressions',
              'campaignClicks',
            ])}
          />
        )}
      </SimpleGrid>
    </>
  )
}
